export type Tab = {
  value: RFI_TABS;
  icon: string;
};

export enum RFI_TABS {
  RFI_DETAILS = 'RFI Details',
  DISCUSSIONS = 'Discussions',
  PACKAGE_DETAILS = 'Package Details',
  SUBMITTALS = 'Submittals',
  TRANSMITTAL_LOG = 'Transmittal Log',
}
